import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import pricingActions from "../../redux/actions";

import backarrow from "../../../../assets/back-arrow-white.svg";
import exit from "../../../../assets/exit.svg";

export default function BackButtonRow() {
  let history = useHistory();
  const dispatch = useDispatch();
  const pricingState = useSelector((state) => state.pricing.uiState);

  const handleBackClick = () => {
    if (pricingState === "plans") {
      history.push("/s2r");
      dispatch(pricingActions.pricingStateChanged("plans"));
    }
    if (pricingState === "checkout")
      dispatch(pricingActions.pricingStateChanged("plans"));
    if (pricingState === "confirmation") {
      history.push("/s2r");
      dispatch(pricingActions.pricingStateChanged("plans"));
    }
    if (pricingState === "enterprise")
      dispatch(pricingActions.pricingStateChanged("plans"));
  };

  const handleExitClick = () => {
    history.push("/s2r");
    dispatch(pricingActions.pricingStateChanged("plans"));
  };

  return (
    <div
      className="row"
      style={{ paddingTop: "2rem", paddingLeft: "2rem", paddingRight: "2rem" }}
    >
      <img
        alt="backarrow"
        onClick={() => {
          handleBackClick();
        }}
        src={backarrow}
        style={{ width: "20px", float: "left" }}
      />
      <img
        alt="exit"
        onClick={() => {
          handleExitClick();
        }}
        src={exit}
        style={{ width: "20px", float: "right" }}
      />
    </div>
  );
}
